<template>
  <div class="contents contents--list">
    <div class="contents--list-subject">
      <span>RichAccountsList</span>
    </div>
    <Table width="900px" data-type="richaccounts" :data="richaccounts"/>
  </div>
</template>

<script>
import Table from "./shared/Table.vue";
import callAPI from "../../api/http";
import {convertAttrFormat} from "../../js/format";
import {styleNav} from "../../js/style";

export default {
  name: "RichAccountsList",

  components: {
    Table,
  },

  async created() {
    await this.getRichAccounts();
  },

mounted() {
    styleNav(6);
  },

  data() {
    return {
      richaccounts: null,
    };
  },

  methods: {
    async getRichAccounts() {
      const {data, errCode} = await callAPI("getRichAccounts");
      this.setRichAccounts(data, errCode);
    },
    setRichAccounts(data, errCode) {
      if (errCode) {
        console.log(errCode);
        return;
      }
      const richaccounts = data.richaccounts;
      if (richaccounts) {
        this.richaccounts = convertAttrFormat("RichAccountsList", richaccounts);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.no-result-msg {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/RichAccountsList.vue